import { render, staticRenderFns } from "./OnboardingPage.vue?vue&type=template&id=77fdec76&"
import script from "./OnboardingPage.vue?vue&type=script&lang=ts&"
export * from "./OnboardingPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports